export type FileExtension = `.${string}`;
export type MimeType = `${
  | 'application'
  | 'audio'
  | 'example'
  | 'font'
  | 'image'
  | 'model'
  | 'text'
  | 'video'}/${string}`;

interface FileInputOption {
  accept?: Array<FileExtension | MimeType>;
  multiple?: boolean;
}

export function getFilesFromLocal({ accept = [], multiple = false }: FileInputOption = {}) {
  return new Promise<FileList | null>((resolve) => {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.capture = 'user';
    inputElement.accept = accept.join(',');
    inputElement.multiple = multiple;

    inputElement.onchange = function () {
      return resolve(inputElement.files);
    };

    inputElement.click();
  });
}
